import { createRoot } from 'react-dom/client';
import {App} from './App';
import "./App.css";

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <App />
);
